import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { formatMoney, getInlineLoader } from "../Helpers";
import { MdSearch } from "react-icons/md";
import OnePayment from "../ones/OnePayment";

export default function View(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [publishedRecs, setPublishedRecs] = useState(null);
  const [unpublishedRecs, setUnpublishedRecs] = useState(null);
  const [recsList, setRecsList] = useState(null);
  const [filter, setFilter] = useState("");
  const [category, setCategory] = useState("all");

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllPayments()]);
    setReady(true);
  }

  function categorizeRecs() {
    if (appContext.allPayments) {
      const _published = appContext.allPayments.filter((item) => item.status === "published");
      const _unpublished = appContext.allPayments.filter((item) => item.status === "unpublished");
      setPublishedRecs(_published);
      setUnpublishedRecs(_unpublished);
    }
  }

  function processRecs() {
    let _list = appContext.allPayments;

    if (category === "unpublished") {
      _list = unpublishedRecs;
    } else if (category === "published") {
      _list = publishedRecs;
    }

    if (filter && filter.trim().length > 0) {
      setRecsList(
        _list?.filter((item) => {
          const value = `${item.model || ""} ${item.fullname || ""}`;
          return value.toLowerCase().indexOf(String(filter).toLowerCase()) > -1;
        })
      );
    } else {
      setRecsList(_list);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    categorizeRecs();
  }, [appContext.allPayments]);

  useEffect(() => {
    processRecs();
  }, [filter, category, appContext.allPayments, publishedRecs, unpublishedRecs]);

  if (ready) {
    const totalCollected = (appContext.allPayments || []).reduce((sum, item) => sum + Number(item.amount || 0), 0);

    return (
      <div className="container">
        <div className="app-page">
          <div className="app-page-hero">
            <div>
              <h6 className="main-section-title">Payments</h6>
              <p className="app-page-subtitle">
                Follow recorded installments and payment history with a cleaner view of customer repayment progress.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="summary-mini-card">
                <span>Total payments</span>
                <strong>{appContext.allPayments?.length || 0}</strong>
              </div>
            </div>
            <div className="col-md-4">
              <div className="summary-mini-card">
                <span>Total collected</span>
                <strong>{formatMoney(totalCollected)}</strong>
              </div>
            </div>
          </div>

          <div className="list-shell">
            <div className="list-toolbar">
              <div className="modern-search">
                <MdSearch size={20} />
                <input className="form-control" onChange={(e) => setFilter(e.target.value)} placeholder="Search payments" />
              </div>

              <select className="form-control modern-filter" value={category} onChange={(e) => setCategory(e.target.value)}>
                <option value="all">All records</option>
                <option value="published">Published</option>
                <option value="unpublished">Unpublished</option>
              </select>
            </div>

            {filter && filter.trim().length > 0 ? <div className="list-feedback">Results for "{filter}"</div> : ""}

            <div className="entity-list">
              {recsList && recsList.length > 0 ? recsList.map((item, i) => <OnePayment key={i} data={item} />) : <div className="empty-state-lite">No payment records were found.</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
